import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// i18n instansiyasi BIRINCHI import qilinadi: `shared/lib/format.ts` uni
// modul darajasida ishlatadi, ya'ni u tayyor bo'lishi kerak
import '@/app/i18n'
import '@/styles/global.css'
import { AppProviders } from '@/app/AppProviders'
import { AppRoutes } from '@/app/router'

const container = document.getElementById('root')
if (!container) throw new Error('#root topilmadi — index.html buzilgan')

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  </StrictMode>,
)
